/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */
import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { createEpicMiddleware } from 'redux-observable';

import { store as sarsaparillaStore, sarsaparillaReducers } from 'sarsaparilla';
import { authReducers } from 'shared-ui/auth/redux';
import { externalRatingReviewsReducers } from 'ui-rating-review';
import moduleReducers from '../src/reducers';

import moduleStore from '../src/store';
import { rootEpic } from './epics';

const rootReducer = combineReducers({
    huntingpermit: moduleReducers,
    ratingReviews: externalRatingReviewsReducers,
    ...sarsaparillaReducers,

    // Auth - MUST COME AFTER SARSA REDUCERS DURING AUTH MIGRATION
    ...authReducers,
});

const initialState = {
    ...moduleStore(),
    ...sarsaparillaStore(),
};

export function setupStore(preloadedState?: any) {
    const epicMiddleware = createEpicMiddleware();

    const newStore = configureStore({
        reducer: rootReducer,
        middleware: (getDefaultMiddleware) => {
            return getDefaultMiddleware({
                immutableCheck: {
                    // TODO: No idea what's happening in here that's mutating
                    ignoredPaths: [
                        'huntingpermit',
                        'huntingpermit.reservation.data.permit_holder',
                        'huntingpermit.reservation.data.extra_fields',
                        'huntingpermit.reservation.data.need_to_know_checked',
                    ],
                },
                serializableCheck: {
                    ignoredActions: ['launchdarkly/setClient'],
                    ignoredPaths: [
                        'launchdarkly', // Has ld client object in reducer
                    ],
                },
            }).concat(epicMiddleware);
        },
        preloadedState,
        devTools: process.env.DEV_TOOLS_ENABLED,
    });

    epicMiddleware.run(rootEpic);

    return newStore;
}

const store = setupStore(initialState);

export { store };

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppStore = typeof store;

// cSpell:ignore reduxjs, huntingpermit
